import { render, staticRenderFns } from "./componentOptions.vue?vue&type=template&id=6c0a8b2b&scoped=true&"
import script from "./componentOptions.vue?vue&type=script&lang=ts&"
export * from "./componentOptions.vue?vue&type=script&lang=ts&"
import style0 from "./componentOptions.vue?vue&type=style&index=0&id=6c0a8b2b&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a8b2b",
  null
  
)

export default component.exports